import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=2fc8fd4f&scoped=true&"
import script from "./Feed.vue?vue&type=script&lang=js&"
export * from "./Feed.vue?vue&type=script&lang=js&"
import style0 from "./Feed.vue?vue&type=style&index=0&id=2fc8fd4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc8fd4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VCol,VRow})
